import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * TreeChevron - Animated disclosure chevron for tree nodes.
 *
 * Renders a single ChevronDown that rotates -90° when collapsed.
 * Uses CSS transition for smooth animation. Always the same DOM element
 * so the browser can animate the transform (unlike swapping ChevronDown/ChevronRight).
 */
export function TreeChevron({ open, className }: { open: boolean; className?: string }) {
  return (
    <ChevronDown
      className={cn(
        "size-3.5 shrink-0 transition-transform duration-150",
        !open && "-rotate-90",
        className
      )}
    />
  );
}
